<template>
  <div class="container mt-4">
    <h2>Novo Orçamento</h2>

    <b-form @submit.prevent="submitForm">
      <b-row>
        <b-col cols="9">
          <b-form-group label-for="code" label="Cód. Orçamento">
            <b-form-input
              v-model="estimate.code"
              type="text"
              id="code"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>

        <b-col cols="3">
          <b-form-group label-for="status" label="Status">
            <b-form-select
              v-model="estimate.status"
              :options="statusOptions"
              id="status"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-form-group label-for="client" label="Cliente">
            <b-form-select
              v-model="estimate.client.id"
              :options="clients"
              id="client"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label-for="seller" label="Vendedor">
            <b-form-select
              v-model="estimate.seller.id"
              :options="sellers"
              id="seller"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="4">
          <b-form-group label-for="estimateDate" label="Data Orçamento">
            <b-form-input
              v-model="estimate.estimateDate"
              type="date"
              id="estimateDate"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group label-for="validity" label="Validade">
            <b-form-input
              v-model="estimate.validity"
              type="date"
              id="validity"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group label-for="forecast" label="Previsão">
            <b-form-input
              v-model="estimate.forecast"
              type="date"
              id="forecast"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group label-for="notes" label="Observações">
            <b-form-textarea
              v-model="estimate.notes"
              id="notes"
              required
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <hr />
      <h3>Itens do Orçamento</h3>

      <b-row>
        <b-col cols="12">
          <b-form-group label-for="product" label="Produto/Serviço">
            <b-form-select
              v-model="newItem.product"
              id="product"
              :options="marketItems"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="4">
          <b-form-group label-for="quantity" label="Quantidade">
            <b-form-input
              v-model.number="newItem.quantity"
              id="quantity"
              type="number"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group label-for="unitPrice" label="Valor Unitário">
            <b-form-input
              v-model.number="newItem.unitPrice"
              type="number"
              id="unitPrice"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-form-group label-for="calculateTotal" label="Valor Total">
            <b-form-input
              v-model="calculateTotal"
              type="text"
              id="calculateTotal"
              disabled
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="ag-theme-alpine-dark" style="height: 250px;">
          <ag-grid-vue
            style="width: 100%; height: 100%;"
            :columnDefs="columnDefs"
            :rowData="items"
            @grid-ready="onGridReady"
            @selection-changed="onSelectionChanged"
            @cell-value-changed="onCellValueChanged"
            :rowSelection="'multiple'"
            :defaultColDef="defaultColDef"
            rowHeight="40"
            :pagination="true"
          ></ag-grid-vue>
        </b-col>
      </b-row>

      <b-button v-if="!isEditing" @click="addItem" variant="primary" size="sm">
        Adicionar Item
      </b-button>

      <b-button v-else @click="updateItem" variant="warning" size="sm">
        Atualizar Item
      </b-button>

      <b-button
        v-if="showEdit"
        variant="primary"
        style="width: 40px;"
        size="sm"
        @click="editItem"
      >
        <i class="tim-icons icon-pencil"></i>
      </b-button>

      <b-button
        v-if="showDelete"
        variant="danger"
        style="width: 40px;"
        size="sm"
        @click="removeItem"
      >
        <i class="tim-icons icon-trash-simple"></i>
      </b-button>

      <b-row>
        <b-col cols="2">
          <b-form-group label-for="discountType" label="Tipo Desconto">
            <b-form-select
              v-model="estimate.discount.type"
              id="discountType"
              :options="discountTypes"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label-for="discountValue" label="Desconto">
            <b-form-input
              v-model="estimate.discount.value"
              id="discountValue"
              type="number"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <hr />
      <h3>Total do Orçamento</h3>

      <b-row>
        <b-col cols="4">
          <h5>Itens Orçamento</h5>
          <h4>R${{ estimate.total.itemsTotal }}</h4>
        </b-col>

        <b-col cols="4">
          <h5>Desconto</h5>
          <h4 style="color: #FFC600">R${{ estimate.total.discountValue }}</h4>
        </b-col>

        <b-col cols="4">
          <h5>Valor Total</h5>
          <h4 style="color: #9cff19">R${{ estimate.total.finalTotal }}</h4>
        </b-col>
      </b-row>

      <hr />

      <b-row>
        <b-col cols="12">
          <b-form-group
            label-for="paymentNotes"
            label="Observações de pagamento"
          >
            <b-form-textarea
              id="paymentNotes"
              v-model="estimate.paymentNotes"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>

      <b-button type="submit" variant="primary">Cadastrar</b-button>
    </b-form>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
export default {
  name: "EnterpriseCrud",
  components: {
    AgGridVue
  },
  data() {
    return {
      estimate: {
        code: "",
        status: "",
        client: { id: "", code: "" },
        seller: { id: "", code: "" },
        dates: {
          estimateDate: "2025-02-07",
          validity: "",
          forecast: ""
        },
        notes: "",
        items: [
          {
            productOrService: "",
            quantity: 0,
            unitPrice: 0,
            totalPrice: 0,
            itemNotes: ""
          }
        ],
        discount: {
          value: 0,
          type: "valor"
        },
        total: {
          itemsTotal: 0,
          discountValue: 0,
          finalTotal: 0
        },
        paymentNotes: ""
      },
      newItem: {
        product: "",
        quantity: 1,
        unitPrice: 0
      },
      items: [],
      columnDefs: [
        {
          checkboxSelection: true,
          headerName: "Produto/Serviço",
          field: "product",
          sortable: true
        },
        {
          headerName: "Quantidade",
          field: "quantity",
          sortable: true
        },
        {
          headerName: "Valor Unitário",
          field: "unitPrice",
          sortable: true
        },
        { headerName: "Valor Total", field: "total", sortable: true }
      ],
      defaultColDef: {
        resizable: true,
        flex: 1
      },
      statusOptions: [
        { value: "", text: "Em Andamento" },
        { value: "pendente", text: "Pendente" },
        { value: "aprovado", text: "Aprovado" }
      ],
      clients: [{ value: "", text: "Selecione um cliente" }],
      sellers: [{ value: "", text: "Selecione um vendedor" }],
      marketItems: [{ value: "", text: "Selecione um item" }],
      discountTypes: [
        { value: "percentual", text: "%" },
        { value: "valor", text: "R$" }
      ],
      gridOptions: {
        onGridReady: this.onGridReady
      },
      showDelete: false,
      showEdit: false,
      isEditing: false
    };
  },
  created() {
    if (this.$route.query.estimate) {
      const getEstimate = JSON.parse(this.$route.query.estimate);
      this.estimate = getEstimate;
    }
  },
  computed: {
    calculateTotal() {
      return (this.newItem.quantity * this.newItem.unitPrice).toFixed(2);
    }
  },
  watch: {
    "estimate.discount.value": function() {
      this.updateTotals();
    },
    "estimate.discount.type": function() {
      this.updateTotals();
    },
    "newItem.quantity": function() {
      this.updateFormTotal();
    },
    "newItem.unitPrice": function() {
      this.updateFormTotal();
    }
  },

  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },

    onRowClicked(event) {
      const rowData = event.data;
      this.$router.push({
        name: "EstimateCrud",
        query: rowData
      });
    },
    addItem() {
      const newItem = {
        product: this.newItem.product,
        quantity: this.newItem.quantity,
        unitPrice: this.newItem.unitPrice,
        total: (this.newItem.quantity * this.newItem.unitPrice).toFixed(2)
      };

      this.items.push(newItem);
      this.updateTotals();
      this.newItem = {
        product: "",
        quantity: 1,
        unitPrice: 0
      };
    },
    removeItem(node) {
      const selectedNodes = this.gridApi.getSelectedNodes();
      const selectedData = selectedNodes.map(node => node.data);
      this.items = this.items.filter(row => !selectedData.includes(row));
      this.updateTotals();
      this.gridApi.deselectAll();
    },
    editItem() {
      const selectedNodes = this.gridApi.getSelectedNodes();
      if (selectedNodes.length !== 1) return;

      const selectedData = selectedNodes[0].data;
      this.newItem = { ...selectedData };
      this.isEditing = true;
    },
    updateItem() {
      const selectedNodes = this.gridApi.getSelectedNodes();
      if (selectedNodes.length !== 1) return;

      const selectedData = selectedNodes[0].data;
      const index = this.items.findIndex(item => item === selectedData);

      if (index !== -1) {
        this.items[index] = { ...this.newItem };
        this.gridApi.setRowData(this.items);
      }
      this.updateTotals();
      this.newItem = {
        product: "",
        quantity: 1,
        unitPrice: 0
      };
      this.gridApi.deselectAll();
      this.isEditing = false;
    },
    updateTotals() {
      if (this.estimate.total) {
        this.estimate.total.itemsTotal = this.items
          .reduce((sum, item) => sum + parseFloat(item.total), 0)
          .toFixed(2);

        if (this.estimate.discount.type === "percentual") {
          this.estimate.total.discountValue = (
            (this.estimate.discount.value / 100) *
            this.estimate.total.itemsTotal
          ).toFixed(2);
        } else {
          this.estimate.total.discountValue = parseFloat(
            this.estimate.discount.value
          ).toFixed(2);
        }

        this.estimate.total.finalTotal = (
          this.estimate.total.itemsTotal - this.estimate.total.discountValue
        ).toFixed(2);
      }
    },
    updateFormTotal() {
      this.newItem.total = (
        this.newItem.quantity * this.newItem.unitPrice
      ).toFixed(2);
    },
    onSelectionChanged() {
      if (!this.gridApi) return;
      this.showDelete = this.gridApi.getSelectedNodes().length > 0;
      this.showEdit = this.gridApi.getSelectedNodes().length == 1;
    },
    onCellValueChanged(params) {
      if (
        params.column.colId === "quantity" ||
        params.column.colId === "unitPrice"
      ) {
        params.data.total = (
          params.data.quantity * params.data.unitPrice
        ).toFixed(2);
        this.updateTotals();
        this.gridApi.refreshCells({ force: true });
      }
    }
  }
};
</script>

<style>
.ag-theme-alpine-dark .ag-root {
  background-color: #1e1e2f !important;
}

.ag-theme-alpine-dark .ag-header,
.ag-theme-alpine-dark .ag-header-cell-label {
  background-color: #1e1e2f;
  color: #ffffffb3 !important;
  font-family: "Poppins";
  font-size: 12px;
}
.ag-theme-alpine-dark {
  border: none !important;
  background-color: #1e1e2f !important;
}

.ag-theme-alpine-dark .ag-root-wrapper {
  background-color: #1e1e2f;
  border: none !important;
}
.ag-theme-alpine-dark .ag-row {
  background-color: #1e1e2f !important;
}
</style>
